module.exports = __webpack_public_path__ + "static/takeaway200-2d7305223333213d00a8d44e78701123.png";